import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./components/App";
import Login from "./views/Login";
import LoginRequiredRoute from "./routers/LoginRequiredRoute";
import { SnackbarProvider } from "notistack";
import * as serviceWorker from "./serviceWorker";
import { Router, Route, Switch } from "react-router-dom";
import history from "./helpers/History";
import { Provider } from "react-redux";
import store from "./store";
import Faturamento from "./views/Faturamento";
import Notifier from "./components/Notifier";
import ConfirmaFatura from "./views/Faturamento/ConfirmaFatura";

ReactDOM.render(
  <Provider store={store}>
    <Router history={history}>
      <SnackbarProvider maxSnack={3}>
        <Notifier />
        <Switch>
          <Route exact path="/login/" component={Login} />
          <LoginRequiredRoute path="/faturamento/:id" component={Faturamento} />
          <LoginRequiredRoute
            path="/ConfirmaFatura"
            component={ConfirmaFatura}
          />
          <LoginRequiredRoute path="/" component={App} />
        </Switch>
      </SnackbarProvider>
    </Router>
  </Provider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
